<div class="row notif" style="margin-right:0">
    <div class="col-12 col-md-2">
        <h2>Notificaciones :</h2>
    </div>
    <div class="col-12 col-md-10">
    </div>
</div>